const C = {
  name: "ShopperBagAction",
  dimensions: { width: 34, height: 41 },
  content: `
    <g fill="currentColor" stroke="none">
        <path d="M28.3622 37.82C24.5622 38.83 21.1722 35.44 22.1822 31.64C22.6222 29.97 23.9722 28.62 25.6422 28.18C29.4422 27.17 32.8322 30.56 31.8222 34.36C31.3822 36.03 30.0322 37.38 28.3622 37.82ZM2.0022 37V10H6.0022V14C6.0022 14.55 6.4522 15 7.0022 15C7.5522 15 8.0022 14.55 8.0022 14V10H20.0022V14C20.0022 14.55 20.4522 15 21.0022 15C21.5522 15 22.0022 14.55 22.0022 14V10H25.0022C25.5522 10 26.0022 10.45 26.0022 11V26.08C22.6122 26.57 20.0022 29.48 20.0022 33C20.0022 34.96 20.8122 36.73 22.1122 38H3.0022C2.4522 38 2.0022 37.55 2.0022 37ZM14.0022 2C17.3122 2 20.0022 4.69 20.0022 8H8.0022C8.0022 4.69 10.6922 2 14.0022 2ZM28.0022 26.08V10C28.0022 8.9 27.1022 8 26.0022 8H22.0022C22.0022 3.59 18.4122 0 14.0022 0C9.5922 0 6.0022 3.59 6.0022 8H2.0022C0.902197 8 0.00219727 8.9 0.00219727 10V38C0.00219727 39.1 0.902197 40 2.0022 40H26.7422C30.4222 40 33.6722 37.27 33.9722 33.6C34.2922 29.82 31.5822 26.6 28.0022 26.08Z"/>
    </g>
  `
};
export {
  C as ShopperBagAction
};
